import { activeRecipientBuff } from './buffModifiers.mjs';
import { exhaustionRollModifiers } from './exhaustion.mjs';
import { auraSaveModifiers } from './auras.mjs';
// One die per spell family: duplicate Bless/Bane casts do not stack. The two
// different spells coexist and roll independent d4s, even with Advantage.
// A modifier is a d4 ({ sides: 4, sign }) or a flat amount with no die ({ flat }: Exhaustion's D20 Test penalty, Aura of
// Protection's saving throw bonus).
// `dice` lists only the d4 results, in modifier order.
export const getRollDiceModifiers = (combat, targetId, context = 'save', defenderId) => {
  if (!['attack', 'save', 'saving-throw', 'death-save'].includes(context)) return [];
  const modifiers = ['bless', 'bane'].flatMap(spell => {
    const effect = (combat?.activeEffects || []).find(item => item.definitionId === `spell:${spell}` &&
      String(item.targetCombatantId) === String(targetId) && item.userVisible !== false &&
      (!item.parentEffectId || (combat.activeEffects || []).some(root => root.id === item.parentEffectId)));
    return effect ? [{ spellId: spell, name: spell === 'bless' ? 'Bless' : 'Bane', sides: 4, sign: spell === 'bless' ? 1 : -1 }] : [];
  });
  if (context === 'attack' && defenderId && activeRecipientBuff(combat, defenderId, 'blade-ward')) modifiers.push({ spellId: 'blade-ward', name: 'Blade Ward', sides: 4, sign: -1 });
  const bond = context !== 'attack' && activeRecipientBuff(combat, targetId, 'warding-bond') ? [{ id: 'warding-bond', name: 'Warding Bond', flat: 1 }] : [];
  return [...modifiers, ...bond, ...(context === 'attack' ? [] : auraSaveModifiers(combat, targetId)), ...exhaustionRollModifiers(combat, targetId)];
};
export const dieModifiers = (modifiers = []) => (modifiers || []).filter(item => !Number.isFinite(item?.flat));
export const modifierDiceGroups = (modifiers = []) => dieModifiers(modifiers).map(() => ({ count: 1, sides: 4 }));
export const modifierDiceTotal = (modifiers = [], dice = []) => {
  const rolled = dieModifiers(modifiers);
  if (!Array.isArray(dice) || dice.length !== rolled.length || dice.some(value => !Number.isInteger(value) || value < 1 || value > 4)) {
    throw Object.assign(new Error('Spell d4 evidence does not match this roll. Retry the original dice.'), { status: 400 });
  }
  return dice.reduce((sum, value, i) => sum + value * rolled[i].sign, 0) + (modifiers || []).reduce((sum, item) => sum + (Number.isFinite(item?.flat) ? item.flat : 0), 0);
};
export const modifierDiceBreakdown = (modifiers = [], dice = []) => {
  let die = 0;
  return (modifiers || []).map(item => Number.isFinite(item?.flat) ? `${item.flat < 0 ? '-' : '+'} ${Math.abs(item.flat)} ${item.name}`
    : `${item.sign > 0 ? '+' : '-'} ${dice[die++]} ${item.name} (d4)`).join(' ');
};
export const modifierDiceRecords = (modifiers = [], dice = []) => dieModifiers(modifiers).map((item, i) => ({ sides: 4, value: dice[i], sign: item.sign, type: item.name, category: 'modifier' }));
export const readModifierDice = (roll, modifiers = []) => {
  const dice = dieModifiers(modifiers).map((_, i) => roll?.rolls?.[i + 1]?.[0]);
  modifierDiceTotal(modifiers, dice);
  return dice;
};
